import React from 'react'
import { useState } from 'react';
import Heading from '../Heading/Heading.js'
import './Portfolio.css'

const Portfolio = () => {

    const tabs = ['All','Website','UI/UX','Photography','Others'];
    const [currentTab,setCurrentTab] = useState('All');
    const portfolio = [
        {
            image : 'https://res.cloudinary.com/facemetaclone/image/upload/v1663877085/Screenshot_2022-09-23_at_1.34.35_AM_ihyvi7.png',
            title : 'Furniture Website',
            category : 'Website'
        },
        {
            image : 'https://res.cloudinary.com/facemetaclone/image/upload/v1663877184/Screenshot_2022-09-23_at_1.36.16_AM_vts77k.png',
            title : 'Gradient UI/UX Design',
            category : 'UI/UX'
        }, 
        {
            image : 'https://res.cloudinary.com/facemetaclone/image/upload/v1663877331/Screenshot_2022-09-23_at_1.38.13_AM_aa1nqr.png',
            title : 'Nature Landing Page',
            category : 'Website'
        },
        {
            image : 'https://img.freepik.com/premium-vector/health-tracking-glassmorphic-design-neumorphic-elements-kit-mobile-app-ui-ux-gui-screens-set_9209-5179.jpg?w=2000',
            title : 'Trading Application',
            category : 'UI/UX'
        },
        {
            image : 'https://images.pexels.com/photos/5103899/pexels-photo-5103899.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
            title : 'Men Portfolio Photoshoot',
            category : 'Photography'
        },
        {
            image : 'https://images.pexels.com/photos/9968540/pexels-photo-9968540.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
            title : 'Women Portfolio Photoshoot',
            category : 'Photography'
        },
        {
            image : 'https://www.designyourway.net/blog/wp-content/uploads/2009/11/vector-wallpaper-2-700x394.jpg',
            title : 'Vector Design',
            category : 'Others'
        }, 
        {
            image : 'https://img.freepik.com/free-vector/blogger-email-template_52683-50729.jpg?w=2000&t=st=1663876697~exp=1663877297~hmac=08172ef3d2ca3ba12fb1b5aaf7a11c65cd59f95a5496b52a1b06501153305208',
            title : 'Restaurant Website',
            category : 'Website'
        },
        {
            image : 'https://img.freepik.com/free-vector/ecommerce-email-template_52683-51673.jpg?w=1480&t=st=1663876753~exp=1663877353~hmac=2a6508d96b1bd3046155f4e7c73696a5bea2170cfe53ce4101ae1dbe64a4d70c',
            title : 'Online Shopping Website',
            category : 'Website'
        },
    ]

  return (
    <div className='portfolioCon' id='portfolio'>
        <Heading thinText="Featured" boldText="Portfolio" />
        <div className="tabContainer">
            {
                tabs.map((tab, i) => {
                    return (
                        <>
                            <span className={tab === currentTab && 'active'} onClick={() => {setCurrentTab(tab)}}>{tab}</span>
                        </>
                    )
                })
            }
        </div>
        <div className="collectionCon">
            <div className="collections">
                {
                    portfolio.map((portfolio, i) => {
                        if(currentTab === 'All'){
                            return (
                                <>
                                    <div className="portfolio">
                                        <div className="imgBx">
                                            <img src={portfolio.image} alt={portfolio.title} />
                                        </div>
                                        <div className="infoCon">
                                            <span>
                                                <h3>{portfolio.title}</h3>
                                                <h4>{portfolio.category}</h4>
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                        else if(currentTab === portfolio.category){
                            return (
                                <>
                                    <div className="portfolio">
                                        <div className="imgBx">
                                            <img src={portfolio.image} alt={portfolio.title} />
                                        </div>
                                        <div className="infoCon">
                                            <span>
                                                <h3>{portfolio.title}</h3>
                                                <h4>{portfolio.category}</h4>
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default Portfolio